import { useState, useMemo, useCallback } from 'react';

import { useIsCountrySettingsAvailable } from '../../../../features/user/useIsCountrySettingsAvailable';

import { OnboardingStep } from './Onboarding';

const onboardingSteps = [
  OnboardingStep.painPoint,
  OnboardingStep.valueProposition,
  OnboardingStep.metrics,
  OnboardingStep.countries,
];

export const useOnboardingSteps = () => {
  const [stepIndex, setStepIndex] = useState(0);
  const isCountrySettingsAvailable = useIsCountrySettingsAvailable();

  const steps = useMemo(() => {
    if (isCountrySettingsAvailable) {
      return onboardingSteps;
    }
    return onboardingSteps.filter((s) => s !== OnboardingStep.countries);
  }, [isCountrySettingsAvailable]);

  const step = steps[stepIndex];

  const goToNextStep = useCallback(() => setStepIndex((prev) => prev + 1), []);
  const goToPreviousStep = useCallback(() => setStepIndex((prev) => prev - 1), []);

  const isLastStep = stepIndex === steps.length - 1;
  const isThirdStepOfFour = steps.length === 4 && stepIndex === 2;
  const stepsCount = steps.length;

  return { step, goToNextStep, goToPreviousStep, isLastStep, isThirdStepOfFour, stepIndex, stepsCount };
};
